<template>
  <div :class="['cart-footer', extraclass]">
    <p class="header">
      {{ $t('cart.yourTotal') }}
    </p>
    <p class="amount">
      <span class="currency">
        {{ currency }}
      </span>
      {{ amount }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    extraclass: {
      default: null,
      type: String
    }},
  computed: {
    amount() {
      return this.order.total_exchange_in_charge_currency
    },
    order() {
      return this.$store.state.order.order
    },
    currency() {
      return this.order.charge_currency
    },
    header() {
      return this.$t('cart.yourTotal')
    }
  }
}
</script>
